import { Resolution } from 'src/types/ViewModel/Resolution';

export default () => {
    const getResolution = (resolution: Resolution): string => {
        const resolutionString = `${resolution.width}x${resolution.height}`;
        return resolution.isDefault ? resolutionString + ' (default)' : resolutionString;
    };

    return {
        getResolution,
    };
};
